// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__FhvmU","ssr-layout":"styles_ssr-layout__hDMqf","layoutContainer":"styles_layoutContainer__ublkC"};